import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { FormLabel, Select, Gap, ModalTitle, ModalButtons } from '~ui-kit';
import { selectOnboardingOrganization } from './ducks';

const OnboardingSelectPage = () => {
  const dispatch = useDispatch();
  const [organization, setOrganization] = useState(null);

  const organizations = useSelector(
    state => state.user?.data?.initialOrganizationOptions
  );
  const organizationOptions = (organizations || []).map(organization => ({
    value: organization.id,
    label: organization.name,
  }));

  const navigate = useNavigate();

  const handleSubmit = () => {
    dispatch(
      selectOnboardingOrganization({
        organizationId: organization.value,
        navigate,
      })
    );
  };

  return (
    <Container>
      <ModalTitle title="Yksikön valinta" />
      <p>
        Profiilillasi on mahdollista käyttää Pakettia useamman eri yksikön alla.
        Hyväksy oletuksena valittu yksikkösi tai vaihda yksikkö kentän
        alasvetovalikon kautta ennen hyväksymistä.
      </p>
      <FormLabel>Yksikkö</FormLabel>
      <Select
        value={organization}
        options={organizationOptions}
        onChange={setOrganization}
      />
      <Gap />
      <ModalButtons
        closeButtonText="Yksikköni ei löydy listasta"
        onCloseButtonClick={() => navigate('/onboarding/lupa')}
        confirmButtonText="Hyväksy valinta"
        onConfirmButtonClick={handleSubmit}
      />
    </Container>
  );
};

const Container = styled.div``;

export default OnboardingSelectPage;
